import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index.js'
import authStorage from './storage/authStorage.js'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    //
    //Default layout
    //
    {
      path: '',
      component: () => import ('./layouts/Default.vue'),
      meta : { requiresAuth : true },
      beforeEnter: (to, from, next) => {
        if (store.state.auth.auth.isLogin) {
          next();
        }
        else if (authStorage.getAuth() != null) {
          //
          //load from storage
          //
          var auth = authStorage.getAuth();
          store.commit('auth/SET_LOGIN_STATE', auth);
          next();
        }
        else {
          next({
            path: '/login',
            params: { nextUrl: to.fullPath }
          })
        }
      },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => import ('./views/dashboards/DashBoard.vue')
        },
        {
          path: '/statistics',
          name: 'dashboard2',
          component: () => import ('./views/dashboards/DashBoard2.vue')
        },
        {
          path: '/pos',
          name: 'pos',
          component: () => import ('./views/pos/Pos.vue')
        },
        {
          path: '/times',
          name: 'times',
          component: () => import ('./views/timeManager/TimeControlContainerView.vue')
        },
        {
          path: '/productstatus',
          name: 'productstatus',
          component: () => import ('./views/products/products/ProductStatusContainerView.vue')
        },
        {
          path: '/menus',
          name: 'menus',
          component: () => import ('./views/products/menus/MenusContainerView.vue')
        },
        {
          path: '/products',
          name: 'products',
          component: () => import ('./views/products/products/ProductsContainerView.vue')
        },
        {
          path: '/categories',
          name: 'categories',
          component: () => import ('./views/products/categories/CategoriesContainerView.vue')
        },
        {
          path: '/openinghours',
          name: 'openinghours',
          component: () => import ('./views/openinghours/OpeningHoursContainer.vue')
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import ('./views/profile/ProfileContainer.vue')
        },
        {
          path: '/orders',
          name: 'orders',
          component: () => import ('./views/orders/OrdersContainerView.vue')
        }

      ]
    },
    //
    //Full layout
    //
    {
      path : '/',
      component : () => import('@/layouts/FullPage.vue'),
      children : [
        {
          path: '/login',
          name: 'login',
          component: () => import('@/pages/Login.vue')
        }
      ]
      
    },
    {
      path: "*",
      name: "404",
      component: () => import('@/pages/Error404.vue')
    }

    
  ]
})
